<template>
  <div>
    <div class="d-flex">
      <v-col cols="4" class="d-flex flex-column">
        <span class="helvetica-medium mr-3 fs-18 d-inline-block mt-2 d-flex">Лицевой счёт:</span>
        <span class="helvetica-medium mr-3 fs-18 d-inline-block mt-2">Адрес:</span>
      </v-col>
      <!--   <BillingPeriodMessage v-on:closeWindow="closeWindow" v-if="isBillingPeriod.value & !closeBillingPeriodMessage" 
      :message="isBillingPeriod.mesHtml"/> -->
      <div class="d-flex flex-column mt-3">
        <div class="helvetica-medium fs-18 d-inline-block mt-2 ml-3 d-flex">
          {{ personalAccount || "Не заполнено" }}
        </div>
        <div class="helvetica-medium address-font d-inline-block mt-2 ml-3 reduce">
          {{ info.address || "Не заполнено" }}
        </div>
      </div>
    </div>
    <div class="d-flex flex-column">
      <v-data-table class="mt-1" :headers="headers" :items="receiptDetails.details" hide-default-footer>
        <template v-slot:item.principalInfo="{ item }">
          <u class="blue--text fs-20" style="cursor:help" @click="showBankDetails(item)"> Реквизиты </u><br />
          <p v-if="item.bankDetails">{{ item.principalInfo.replace(/,/g, ", ") }}</p>
        </template>
        <template v-slot:item.toPayEPD="{ item }">
          <p>{{ item.toPayEPD }}</p>
        </template>
        <template v-slot:item.toPay="{ item }">
          <v-layout class="ml-3">
            <v-currency-field
              classes="mt-2 input-fs-18 d-inline-block helvetica-bold max-w-200"
              v-model="item.toPay"
              outlined
              :disabled="false"
              :filled="false"
              placeholder="0"
            >
            </v-currency-field>
          </v-layout>
        </template>
      </v-data-table>
    </div>
    <div class="d-flex">
      <v-col sm="5" class="d-flex flex-column">
        <span class="helvetica-medium mr-3 fs-18 d-inline-block mt-2">Итого к оплате за электроэнергию:</span>
      </v-col>
      <div class="d-flex flex-column mt-3">
        <v-text-field outlined v-model="payment" class="mt-2" style="width: 150px;" disabled>
          <template v-slot:append>.руб</template>
        </v-text-field>
      </div>
    </div>
    <div class="grey--text font-italic d-flex mobilefont">
      К оплате принимаются карты международных платежных систем MasterCard, Visa и НСПК МИР, выпущенные любым банком.
      Оплата осуществляется без комиссии на платежной странице ПАО "АК БАРС БАНК"
    </div>
    <div class="d-flex flex-column mt-5">
      <div class="helvetica-medium fs-18 d-inline-block mt-2">Выберите способ получения информации о платеже*:</div>
      <div class="d-flex">
        <v-col sm="4" class="d-flex flex-column">
          <v-checkbox v-model="email.check" label="E-Mail:" class="mr-3 fs-18 d-inline-block mt-2" />
          <v-checkbox v-model="tel.check" label="Номер телефона:" class="mr-3 fs-18 d-inline-block mt-4" />
        </v-col>
        <div class="d-flex flex-column mt-3">
          <v-text-field
            outlined
            class="mt-2"
            v-model="email.value"
            :rules="emailRules"
            :disabled="!email.check"
          ></v-text-field>
          <v-text-field
            outlined
            v-model="tel.value"
            :disabled="!tel.check"
            :rules="phoneRules"
            v-mask="'+7(###)###-##-##'"
          ></v-text-field>
        </div>
      </div>
      <div class="grey--text font-italic">Поля со знаком * обязательны для заполнения.</div>
    </div>
    <div>
      <v-btn class="white-button white--text mt-6 mr-6" depressed @click="$emit('paymentWindowOff')">Отмена</v-btn>
      <v-btn class="green-button white--text mt-6" depressed :disabled="!disabled" :loading="loading" @click="doPay"
        >Оплатить</v-btn
      >
    </div>
    <modal-service-unvailable v-if="showModalPayment" v-model="showModalPayment" />
    <ModalCertificate v-model="showModalCertificate" @change="proceedToPayment" />
  </div>
</template>

<script>
import { AxiosWrapper } from "../../assets/api/AxiosWrapper";
import { mask } from "vue-the-mask";
import { mapState } from "vuex";
import VCurrencyField from "../../components/common/VCurrencyField";
import BillingPeriodMessage from "../../components/common/BillingPeriodMessage";
import ModalServiceUnvailable from "../../components/modals/ModalServiceUnvailable.vue";
import ModalCertificate from "../../components/modals/ModalCertificate.vue";

export default {
  name: "PaymentChild",
  components: {
    VCurrencyField,
    BillingPeriodMessage,
    ModalServiceUnvailable,
    ModalCertificate
  },
  props: ["personalAccount", "info", "receiptDetails", "closeBillingPeriodMessage"],

  data: () => ({
    email: {
      value: "",
      check: false
    },
    tel: {
      value: "+7",
      check: false
    },
    loading: false,
    showModalPayment: false,
    showModalCertificate: false,
    headers: [
      {
        text: "Код исполнителя",
        align: "center",
        value: "principalCode",
        sortable: false,
        class: "subtitle-1 font-weight-bold",
        th: {
          style: {
            height: "80px"
          }
        }
      },
      {
        text: "Наименование организации",
        align: "center",
        value: "principalName",
        class: "subtitle-2 font-weight-bold",
        sortable: false
      },
      {
        text: "Реквизиты исполнителя",
        align: "center",
        value: "principalInfo",
        width: "30%",
        class: "subtitle-2 font-weight-bold"
      },
      {
        text: "Сумма по ЕПД, руб.",
        align: "center",
        value: "toPayEPD",
        class: "subtitle-2 font-weight-bold"
      },
      {
        text: "Сумма к оплате, руб.",
        align: "center",
        value: "toPay",
        sortable: false,
        class: "subtitle-2 font-weight-bold"
      }
    ],
    emailRules: [
      v => !!v || "Введите e-mail",
      v => /^[^'"\|`~{}\[\]\/()\\=,<>\s\t]+$/.test(v) || "Введены недопустимые символы",
      v => /^\w+([.-]?\w+)*@\w+([.-]?\w+)*(\.\w{2,4})+$/.test(v) || "Некорректный E-mail"
    ],
    phoneRules: [v => !!v || "Номер телефона", v => v.length > 15 || "Некорректный телефон"]
  }),
  directives: { mask },
  computed: {
    disabled() {
      if (parseFloat(this.payment) <= 0) {
        return false;
      } else if (this.email.check) {
        return !!/^\w+([.-]?\w+)*@\w+([.-]?\w+)*(\.\w{2,4})+$/.test(this.email.value);
      } else if (this.tel.check) {
        return !!/^\+7\(\d{3}\)\d{3}-\d{2}-\d{2}/.test(this.tel.value);
      } else {
        return false;
      }
    },
    payment() {
      let details = this.receiptDetails.details.map(item => {
        if (!item.toPay) item.toPay = 0;
        return item;
      });

      var payment = details.reduce((a, { toPay }) => parseFloat(a) + parseFloat(toPay), 0);
      return payment.toFixed(2);
    }
  },
  watch: {
    "email.check": {
      immediate: true,
      handler(value) {
        if (value) {
          this.tel.check = false;
        }
      }
    },
    "tel.check": {
      immediate: true,
      handler(value) {
        if (value) {
          this.email.check = false;
        }
      }
    }
  },
  methods: {
    proceedToPayment() {
      this.loading = true;
      let postData = {
        appVersion: "LKFL",
        domHoz: this.personalAccount,
        amount: this.payment,
        details: this.receiptDetails.details.map(({ principalCode, toPay }) => ({ principalCode, toPay }))
      };
      this.tel.check && this.tel.value ? (postData.phone = this.telEncode(this.tel.value)) : false;
      this.email.check && this.email.value ? (postData.email = this.email.value) : false;
      AxiosWrapper.post("DoPay", postData).then(response => {
        if (response.data.success) {
          window.open(response.data.url, "_top");
        } else {
          this.loading = false;
          this.showModalPayment = true;
          /*    this.$store.commit("common/" + "ADD_ALERT", {
            type: "error",
            text: response.data.message || "Произошла ошибка!"
          });*/
        }
      });
    },
    onCertificateClose(value) {
      if (!value) {
        this.showModalCertificate = false;
        this.proceedToPayment();
      }
    },
    doPay() {
      this.showModalCertificate = true;
    },
    closeWindow() {
      this.closeBillingPeriodMessage = true;
    },
    telEncode(tel) {
      let encodedTel = tel.replace(/\D/g, "");
      return encodedTel[0] == "7" ? `+${encodedTel}` : encodedTel;
    },
    telMask(e) {
      const regExp = /^(\+\d|\d)\(\d{3}\)(\d+)$/;
      //console.log(e);
      let newStr = "";
      if (e.length < 6) {
        newStr = e.replace(/^(\+\d|\d)(\d{3})/, "$1($2)");
        return newStr;
      }
      if (e.length > 8) {
        let lettersAfterPar = e.replace(/^(\+\d|\d)(\(\d{3}\))(\d+|[\d-]+)$/, "$3");
        lettersAfterPar = lettersAfterPar.replace(/-/g, "");
        lettersAfterPar = lettersAfterPar.replace(/^(\d{3})(\d*)$/, "$1-$2");
        lettersAfterPar = lettersAfterPar.replace(/(-\d{2})/g, "$1-");
        lettersAfterPar = lettersAfterPar.replace(/(.+)(-)$/, "$1");
        //console.log(lettersAfterPar);
        newStr = e.replace(/^(\+\d|\d)(\(\d{3}\))(\d+|[\d-]+)$/, `$1$2${lettersAfterPar}`);
        //console.log(newStr);
        return newStr;
      }
      return e;
    },

    showBankDetails(item) {
      item.bankDetails = !item.bankDetails;
    },

    disableField(item) {
      item.isEnabled = !item.isEnabled;
      item.isEnabled ? (item.toPay = item.toPayEPD) : (item.toPay = 0);
      this.$store.dispatch("guest/updateReceiptDetails", item);
    }
  },
  mounted() {
    this.$nextTick();
    this.$nextTick();
    this.$nextTick();
  }
};
</script>

<style scoped>
.d-flex {
  flex-wrap: nowrap;
}

.address-font {
  font-size: 1.5vh;
}

@media screen and (max-width: 768px) {
  .d-flex {
    display: flex;
    width: 70vw;
    line-height: 1.2;
  }
  .reduce {
    width: 200px;
    overflow: hidden;
    display: inline-block;
    text-overflow: ellipsis;
    white-space: nowrap;
  }
  .fs-18 {
    font-size: 12px;
  }
  .mobilefont {
    font-size: 10px;
  }
}
</style>
